import { get, post } from '@/utils/request/mAxios';
import APIs from './index';
import { UserInfo } from '@/typings/common';
import errCode from '@/utils/request/errCode';

export function getUserInfo(params: {
  returnUrl: string;
}) {
  return get<UserInfo>(APIs.getUserInfo, { ...params });
}

export async function logout() {
  const { data, code } = await post<string>(APIs.logout, {});
  if (code === errCode.EXPIRE_LOGIN || code === errCode.SUCCESS) {
    window.location.href = data;
  }
}
